import Bugsnag from '@bugsnag/js';
import store from 'store';
import { setUnreadMessages } from 'store/slices/zendesk-slice';

declare global {
  interface Window {
    zE: any;
  }
}

export const hideZendesk = () => {
  window.zE?.('messenger', 'hide');
  window.zE?.('messenger:on', 'close', function () {
    window.zE?.('messenger', 'hide');
  });
};

export const logoutZendesk = () => {
  window.zE?.('messenger', 'logoutUser');
};

export const openZendesk = () => {
  //window.zE?.('messenger', 'show');
  window.zE?.('messenger', 'open');
};

export const loginZendesk = (token: string) => {
  try {
    window.zE?.('messenger', 'loginUser', (callback: (jwt: string) => void) => {
      callback(token);
    });
  } catch (e: any) {
    Bugsnag.notify(e);
  }
};

window.zE?.('messenger:on', 'unreadMessages', function (count: number) {
  store.dispatch(setUnreadMessages(count));
});